import React from 'react'
import style from './style.module.css'
export const Footer = () => {
  return (
    <div className={style.footer}>
      <span>
        Takeaway.com European Operations B.V. | Oosterdoksstraat 80 | 1011DK
        Amsterdam
      </span>
      <span>&copy; 2021 Takeaway.com</span>
    </div>
  )
}

export default Footer
